import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { TbaRangeResult } from '../models';

@Injectable()
export class RangeResultsService extends BaseService<TbaRangeResult> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public listRangeResults(tbaId: number): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}tba/${tbaId}`);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}range-results/`;
  }
}
